import { Link } from "@inertiajs/react";
import { cn } from "@/lib/utils";
import { formatRoom } from "@/lib/classroom";

/**
 * For teachers with more than one classroom in the campaign: a row of
 * pills to move between them. Nothing for everyone else.
 */
export default function ClassroomSwitcher({ classrooms = [], currentId }) {
  if (classrooms.length < 2) return null;

  return (
    <nav aria-label="Your classrooms" className="flex flex-wrap gap-2">
      {classrooms.map((classroom) => {
        const current = classroom.id === currentId;
        return (
          <Link
            key={classroom.id}
            href={classroom.path}
            aria-current={current ? "page" : undefined}
            className={cn(
              "inline-flex min-h-11 items-center rounded-full border px-4 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
              current ? "border-primary bg-primary/10 text-primary" : "border-border bg-card text-muted-foreground hover:text-foreground"
            )}
          >
            {formatRoom(classroom.name)}
          </Link>
        );
      })}
    </nav>
  );
}
